var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24.5C48.5 37.7548 37.7548 48.5 24.5 48.5C11.2452 48.5 0.5 37.7548 0.5 24.5C0.5 11.2452 11.2452 0.5 24.5 0.5C37.7548 0.5 48.5 11.2452 48.5 24.5Z",
    fill: "#CAD6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9984 36.5V29.3H19.3984L22.4584 20.12C22.6184 19.6 22.9134 19.2 23.3434 18.92C23.7734 18.64 24.2584 18.5 24.7984 18.5C25.3384 18.5 25.8234 18.64 26.2534 18.92C26.6834 19.2 26.9784 19.6 27.1384 20.12L30.1984 29.3H26.5984V36.5H22.9984ZM24.7984 17.3C24.1384 17.3 23.5734 17.065 23.1034 16.595C22.6334 16.125 22.3984 15.56 22.3984 14.9C22.3984 14.24 22.6334 13.675 23.1034 13.205C23.5734 12.735 24.1384 12.5 24.7984 12.5C25.4584 12.5 26.0234 12.735 26.4934 13.205C26.9634 13.675 27.1984 14.24 27.1984 14.9C27.1984 15.56 26.9634 16.125 26.4934 16.595C26.0234 17.065 25.4584 17.3 24.7984 17.3Z",
    fill: "#021922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletWomen);
export default __webpack_public_path__ + "static/media/Toilet Women.d2554f6fded46e37cdd582060694a636.svg";
export { ForwardRef as ReactComponent };